import { Slider } from "@/components/ui/slider";
import { hasAmount, hasVariance, EDGE_CONTROLS } from "@/lib/edgeStyles";

// EdgeControls — the smart slider(s) for an edge. One "amount" slider; edges
// that support randomness (jagged / grunge / deckled) get a second smaller
// "variance" slider beside it. Renders nothing for edges with no adjustment.
export default function EdgeControls({ edge, amount, variance, onChange, onCommit }) {
  if (!hasAmount(edge)) return null;
  const c = EDGE_CONTROLS[edge];
  const twin = hasVariance(edge);
  const head = "text-[10px] uppercase tracking-[0.18em] text-[#6B6A68] mb-1 flex justify-between";
  return (
    <div className="flex items-end gap-4" data-testid="edge-controls">
      <div className="flex-1">
        <div className={head}><span>{c.amount}</span><span className="tabular-nums text-[#4A5D4E]">{amount}</span></div>
        <Slider value={[amount]} min={0} max={100} step={5}
          onValueChange={([val]) => onChange({ amount: val, variance })}
          onValueCommit={onCommit} data-testid="edge-amount-slider" />
      </div>
      {twin && (
        <div className="flex-1">
          <div className={head}><span>{c.variance}</span><span className="tabular-nums text-[#4A5D4E]">{variance}</span></div>
          <Slider value={[variance]} min={0} max={100} step={5}
            onValueChange={([val]) => onChange({ amount, variance: val })}
            onValueCommit={onCommit} data-testid="edge-variance-slider" />
        </div>
      )}
    </div>
  );
}
